var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserMinusLine = function SvgUserMinusLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.667 13.877v1.741A5 5 0 0 0 7 20.334H5.333a6.667 6.667 0 0 1 8.334-6.457M12 12.834a5 5 0 0 1-5-5c0-2.763 2.238-5 5-5s5 2.237 5 5a5 5 0 0 1-5 5m0-1.667a3.33 3.33 0 0 0 3.333-3.333 3.332 3.332 0 1 0-6.667 0A3.33 3.33 0 0 0 12 11.166ZM21.167 17v1.667H14.5V17z"
  })));
};
export default SvgUserMinusLine;